import { useState } from 'react'

type FilterType = { [key: string]: number | string | undefined | boolean }

/**
 * Hoook to allow the grid control the filters
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @returns
 */
const useGridFilter = (): [FilterType, (e: React.ChangeEvent<HTMLInputElement>) => void] => {
    const [filterValues, setFilterValues] = useState<FilterType>({})
    const handleChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target || {}
        setFilterValues({
            ...filterValues,
            [name]: value
        })
    }
    return [filterValues, handleChangeFilter]
}

export default useGridFilter
